import type { ReactNode } from 'react';
import type { Breakpoint } from '@mui/material/styles';
import type { NavSectionProps } from 'src/components/nav-section';

import { mergeClasses } from 'minimal-shared/utils';

import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';

import { NavSectionHorizontal } from 'src/components/nav-section';

import { layoutClasses } from '../core';

// ----------------------------------------------------------------------

export type NavHorizontalProps = NavSectionProps & {
  layoutQuery?: Breakpoint;
  rightSlot?: ReactNode;
};

export function NavHorizontal({
  sx,
  data,
  className,
  rightSlot,
  checkPermissions,
  layoutQuery = 'md',
  ...other
}: NavHorizontalProps) {
  return (
    <Box
      className={mergeClasses([layoutClasses.nav.root, layoutClasses.nav.horizontal, className])}
      sx={[
        (theme) => ({
          width: 1,
          position: 'relative',
          flexDirection: 'column',
          display: { xs: 'none', [layoutQuery]: 'flex' },
          borderBottom: `solid 1px ${theme.vars.palette.border}`,
        }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <Divider
        sx={{
          top: 0,
          left: 0,
          width: 1,
          zIndex: 9,
          position: 'absolute',
          borderStyle: 'solid',
        }}
      />

      <Box
        sx={{
          px: 1.5,
          position: 'relative',
          height: 'var(--layout-nav-horizontal-height)',
          backgroundColor: 'var(--layout-nav-horizontal-bg)',
          backdropFilter: `blur(var(--layout-header-blur))`,
          WebkitBackdropFilter: `blur(var(--layout-header-blur))`,
        }}
      >
        <NavSectionHorizontal data={data} checkPermissions={checkPermissions} {...other} />
        {rightSlot && (
          <Box
            sx={{
              top: 0,
              right: 12,
              bottom: 0,
              display: 'flex',
              position: 'absolute',
              alignItems: 'center',
            }}
          >
            {rightSlot}
          </Box>
        )}
      </Box>
    </Box>
  );
}
